import React, { useEffect, useState } from "react";
import * as Styled from "../styles";
import { ASSETS } from "../../../utils/config";
import TextView from "../../TextView";
import Icon from "assets/images/settings/account2.svg";
import PasswordIcon from "assets/images/settings/otp.svg";
import styled from "styled-components";
import Button from "../../Button";
import { colors } from "../../../utils";
import { useSelector, useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { AccountTitle, Content, StyledTitle, ButtonContainer } from "./styles";
import OTPModal from "../../PasswordAlert";
import CustomPhoneInput from "../../PhoneInput";
import {
  OTPContainer,
  StyledDialogActions,
  ResendButton,
} from "../Password/styles";
import CircularProgress from "@mui/material/CircularProgress";
import {
  useSendPhoneOtp,
  useVerifyPhoneOtp,
  useVerifyPassword,
  useRemovePhone2fa,
} from "../../../services/mutations";
import Input from "../../Input";
import { editUserProfileAction } from "../../../redux/actions/user";
import IyugaTooltip from "../../IyugaTooltip";
import { isValidPhoneNumber } from "react-phone-number-input";

const Image = styled.img`
  margin-right: 10px;
`;

const Heading = styled.div`
  margin-top: 32px;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
`;

const Separator = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${colors.lightBorder};
  margin-top: 20px;
`;

const ButtonWrapper = styled.div`
  margin-top: 10px;
  display: flex;
  align-items: center;
  width: 50%;
`;

function Account() {
  const [password, setPassword] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [value, setValue] = useState("");

  const [showModal, setShowModal] = useState(false);

  const [numberStep, setNumberStep] = useState(1);
  const [passwordStep, setPasswordStep] = useState(false);
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [resendLoad, setResendLoad] = useState(false);
  const [loading, setLoading] = useState(false);
  const [phoneData, setPhoneData] = useState({
    phoneNumber: "",
    countryCode: "",
  });
  const [phoneValidationError, setPhoneValidationError] = useState("");

  const { userProfile } = useSelector((state) => state.userProfile);

  const dispatch = useDispatch();

  const sendOtpToPhone = useSendPhoneOtp();
  const verifyPhoneOtp = useVerifyPhoneOtp();
  const verifyUserPassword = useVerifyPassword();
  const removePhone2fa = useRemovePhone2fa();

  useEffect(() => {
    if (userProfile?.phone_number) {
      setPhoneNumber(userProfile.phone_number);
    }
  }, [userProfile]);

  const closeModal = () => {
    setShowModal(false);
    setNumberStep(1);
  };

  const closePasswordModal = () => {
    setPassword("");
    setShowModal(false);
    setPasswordStep(false);
  };

  const handleAddNumber = async () => {
    setShowModal(true);
  };

  const handleChangeNumber = async () => {
    setShowModal(true);
  };

  const handleRemoveNumber = async () => {
    setPasswordStep(true);
    setShowModal(true);
  };

  const handleChange = (value, index) => {
    if (!/^[0-9]*$/.test(value)) return;

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    if (value && index < otp.length - 1) {
      const nextInput = document.getElementById(`otp-input-${index + 1}`);
      nextInput?.focus();
    }
  };

  const handleKeyDown = (event, index) => {
    if (event.key === "Backspace" && otp[index] === "") {
      const prevInput = document.getElementById(`otp-input-${index - 1}`);
      prevInput?.focus();
    }
  };

  // Validate phone number and set error
  const validatePhoneNumber = (phoneNumber) => {
    if (!phoneNumber) {
      setPhoneValidationError("");
      return;
    }

    if (!isValidPhoneNumber(phoneNumber)) {
      setPhoneValidationError("Please enter a valid phone number");
    } else {
      setPhoneValidationError("");
    }
  };

  // Handle phone number change
  const handlePhoneNumberChange = ({ phoneNumber, countryCode }) => {
    setPhoneData({ phoneNumber, countryCode });
    validatePhoneNumber(phoneNumber);
  };

  const sendOtp = () => {
    setLoading(true);
    const formattedNumber = phoneData.phoneNumber.replace(
      `+${phoneData.countryCode}`,
      ""
    );
    sendOtpToPhone.mutateAsync(
      {
        email: userProfile?.email,
        phone_number: formattedNumber,
        country_code: `+${phoneData.countryCode}`,
      },
      {
        onSuccess: (response) => {
          toast.success("An OTP is sent to your phone number!");
          setLoading(false);
          setNumberStep(2);
        },
        onError: (err) => {
          console.log("err", err);
          toast.error(err.response.data.message);
          setLoading(false);
        },
      }
    );
  };

  const verifyOtp = () => {
    const otpCode = otp.join("");
    const formattedNumber = phoneData.phoneNumber.replace(
      `+${phoneData.countryCode}`,
      ""
    );
    verifyPhoneOtp.mutateAsync(
      {
        email: userProfile?.email,
        phone_number: formattedNumber,
        country_code: `+${phoneData.countryCode}`,
        otp: otpCode,
      },
      {
        onSuccess: (response) => {
          setLoading(false);
          closeModal();
          const is2faEnabled = userProfile?.is2faEnabled;
          dispatch(
            editUserProfileAction({
              phone_number: formattedNumber,
              country_code: `+${phoneData.countryCode}`,
              is2faEnabled: true,
            })
          );
          setOtp(["", "", "", "", "", ""]);
          setPhoneData({ phoneNumber: "", countryCode: "" });
          toast.success(
            is2faEnabled
              ? "Number changed successfully."
              : "Number added successfully."
          );
        },
        onError: (err) => {
          console.log("err", err);
          toast.error(err.response.data.message);
          setLoading(false);
        },
      }
    );
  };

  const verifyPassword = () => {
    setLoading(true);
    verifyUserPassword.mutateAsync(
      {
        password: password,
      },
      {
        onSuccess: async (response) => {
          try {
            await removePhone2fa.mutateAsync(
              {
                phone_number: userProfile?.phone_number,
                country_code: userProfile?.country_code,
              },
              {
                onSuccess: () => {
                  dispatch(
                    editUserProfileAction({
                      phone_number: null,
                      country_code: null,
                      is2faEnabled: false,
                    })
                  );
                  setPassword("");
                  setLoading(false);
                  closePasswordModal();
                  toast.success(
                    "Your Phone Number is removed from the two factor authentication."
                  );
                },
              }
            );
          } catch (err) {
            setLoading(false);
            toast.error("Error removing your Phone number. Please try again.");
          }
        },
        onError: (err) => {
          toast.error(err.response.data.message);
          setLoading(false);
        },
      }
    );
  };

  return (
    <Styled.CenterWrapper>
      <Styled.ContentHeader>
        <Styled.HeaderIcon src={Icon} />
        <AccountTitle>
          <TextView variant="title">Account</TextView>
        </AccountTitle>
      </Styled.ContentHeader>
      <Content>
        <StyledTitle>Two Factor Authentication</StyledTitle>
        <TextView
          variant="subtitle"
          style={{ margin: "10px 0px", color: "#565556" }}
        >
          Take control of your account's safety: Two-Factor Authentication adds
          an extra shield to your account, ensuring only you can access it.
        </TextView>
        {/* <TextView variant="subtitle" style={{ color: "#565556" }}>
          Select your preferred 2FA method:
        </TextView>
        <Heading>
          <Image src={ASSETS.authenticator} />
          <StyledTitle variant="subtitle">Authenticator App</StyledTitle>
        </Heading>
        <TextView variant="subtitle" style={{ color: "#565556" }}>
          Generate one-time codes with your preferred authenticator app.
        </TextView>
        <ButtonContainer>
          <IyugaTooltip tooltip="Coming Soon.">
            <Button variant={"primary"} style={{width: "100px"}} disabled={true}>Enable</Button>
          </IyugaTooltip>
        </ButtonContainer> */}
        <Separator />
        <Heading>
          <Image src={ASSETS.sms} />
          <StyledTitle>SMS Authentication</StyledTitle>
        </Heading>
        <TextView variant="largeText" style={{ marginTop: "15px" }}>
          Verify your account instantly via SMS: Add your phone number for quick
          and secure authentication.{" "}
        </TextView>
        {userProfile?.is2faEnabled ? (
          <ButtonWrapper>
            <Button onClick={handleChangeNumber} variant="primary">
              Change Number
            </Button>
            <Button
              onClick={(e) => {
                e.preventDefault();
                handleRemoveNumber();
              }}
              variant="secondary"
              style={{
                border: "1px solid #ED4337",
                color: "#ED4337",
                fontSize: "16px",
                marginLeft: 20,
              }}
            >
              Remove Number
            </Button>
          </ButtonWrapper>
        ) : (
          <ButtonWrapper>
            <Button
              onClick={handleAddNumber}
              variant="primary"
              style={{
                width: 180,
              }}
            >
              Add Phone Number
            </Button>
          </ButtonWrapper>
        )}
      </Content>

      <OTPModal
        open={showModal}
        handleClose={passwordStep ? closePasswordModal : closeModal}
        icon={passwordStep ? PasswordIcon : ASSETS.SMSNew}
        title={passwordStep ? "Enter Password" : "SMS Authentication"}
      >
        <div>
          <TextView
            variant="subtitle"
            style={{ color: "#565556", fontWeight: 700 }}
          >
            {passwordStep && "Enter Password to remove your number"}
            {!passwordStep &&
              (numberStep === 1
                ? "Enter your phone number and receive a text message with a verification code."
                : "Enter the OTP you received via text message on your phone.")}
          </TextView>

          {passwordStep && (
            <div style={{ marginTop: "32px" }}>
              <Input
                name="user_password"
                type="password"
                placeholder="Password"
                onChange={(e) => {
                  setPassword(e.target.value);
                }}
                value={password}
                style={{ maxWidth: 350 }}
                autoComplete="new-password"
              />
            </div>
          )}

          {!passwordStep &&
            (numberStep === 1 ? (
              <>
                <CustomPhoneInput
                  onChange={handlePhoneNumberChange}
                  value={phoneData.phoneNumber}
                />
                {phoneValidationError && (
                  <TextView
                    variant="small"
                    style={{
                      color: "#ED4337",
                      fontSize: "12px",
                      marginTop: "4px",
                    }}
                  >
                    {phoneValidationError}
                  </TextView>
                )}
              </>
            ) : (
              <OTPContainer>
                {otp.map((_, index) => (
                  <input
                    key={index}
                    id={`otp-input-${index}`}
                    type="text"
                    maxLength="1"
                    value={otp[index]}
                    onChange={(e) => handleChange(e.target.value, index)}
                    onKeyDown={(e) => handleKeyDown(e, index)}
                  />
                ))}
              </OTPContainer>
            ))}

          <Separator />

          {!passwordStep ? (
            <StyledDialogActions>
              {resendLoad ? (
                <CircularProgress
                  size={20}
                  style={{ color: "#495057", marginRight: "5px" }}
                />
              ) : (
                <ResendButton onClick={numberStep === 1 ? closeModal : sendOtp}>
                  {numberStep === 1 ? "Cancel" : "Resend"}
                </ResendButton>
              )}
              <Button
                onClick={numberStep === 1 ? sendOtp : verifyOtp}
                width={"auto"}
                isLoading={loading}
                disabled={
                  numberStep === 2
                    ? otp.some((char) => char === "")
                    : phoneData.phoneNumber === "" ||
                      phoneValidationError !== ""
                }
              >
                Send
              </Button>
            </StyledDialogActions>
          ) : (
            <StyledDialogActions>
              <ResendButton onClick={closePasswordModal}>Cancel</ResendButton>
              <Button
                onClick={verifyPassword}
                width={"auto"}
                isLoading={loading}
                disabled={password === ""}
              >
                Continue
              </Button>
            </StyledDialogActions>
          )}
        </div>
      </OTPModal>
    </Styled.CenterWrapper>
  );
}

// Mock API functions
async function validatePassword(password) {
  // Mock API call
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      if (password === "password123") {
        resolve();
      } else {
        reject(new Error("Invalid password"));
      }
    }, 1000);
  });
}

async function sendVerificationCode(phoneNumber) {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve();
    }, 1000);
  });
}

async function verifyCode(verificationCode) {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      if (verificationCode === "123456") {
        resolve();
      } else {
        reject(new Error("Invalid verification code"));
      }
    }, 1000);
  });
}

export default Account;
